(function() {
  window.typeService = {
    get(data) {
      return axios.get(`/api/type/get.php`);
    },
    save(data) {
      return axios.post('/api/type/save.php', data);
    }
  }
})();